<template lang="pug">
  #select-options-withdrawals(v-if="store")
    b-form-group(style="min-width: 200px; flex-wrap: nowrap;")
      b-form-radio(v-model="selected" value="normal" @change="change") Hasta las 23:59 p.m
      b-form-radio(v-model="selected" value="accept" @change="change") Hasta las 9:59 a.m
      b-form-radio(v-model="selected" value="reject" @change="change") Rechazar siempre
      b-form-radio(v-model="selected" value="unlimited" @change="change") Sin restricción
      b-form-radio(v-model="selected" value="variable" @change="change")
        span Horario variable mismo día
        .material-icons-outlined.btn-icon.ml-2(
          style="flex-wrap: nowrap; vertical-align: middle; font-size: 1.3rem;"
          v-if="selected === 'variable'"
          :id="`edit-variable-schedule-${store.id}`"
          variant="primary"
          @click="openModal"
        ) edit
          b-tooltip(:target="`edit-variable-schedule-${store.id}`" triggers="hover") Editar horario variable
        span.d-flex(v-if="store.hasVariableSchedule") ({{ formatTime(variableSchedule) }})
    //- Modal para editar el horario variable
    b-modal(
      :id="`edit-variable-schedule-${store.id}`"
      title="Editar horario variable"
      @ok="saveVariableSchedule"
      @cancel="variableSchedule = store.variableScheduleTime || '12:00'"
      ok-title="Guardar"
      cancel-title="Cancelar"
    )
      b-form-timepicker(
        v-model="variableSchedule"
        locale="es"
        :hour12="false"
      )
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selected: null,
      variableSchedule: '12:00', // Valor por defecto para el horario variable (12 PM)
      showModal: false // Controla la visibilidad del modal
    }
  },
  computed: {
    ...mapGetters(['statusStores'])
  },
  methods: {
    ...mapActions(['updateStore']),
    setSelected (value) {
      if (value.alwaysAcceptWithdrawals) this.selected = 'accept'
      if (value.alwaysRejectWithdrawals && !value.alwaysAcceptWithdrawals) this.selected = 'reject'
      if (!value.alwaysAcceptWithdrawals && !value.alwaysRejectWithdrawals) this.selected = 'normal'
      if (value.alwaysAcceptWithdrawals && value.alwaysRejectWithdrawals) this.selected = 'unlimited'
      if (value.hasVariableSchedule) {
        this.selected = 'variable'
        this.variableSchedule = value.variableScheduleTime // Cargar el horario variable desde la tienda
      }
    },
    async change (value) {
      const data = {
        alwaysAcceptWithdrawals: false,
        alwaysRejectWithdrawals: false,
        hasVariableSchedule: false,
        variableScheduleTime: null
      }
      if (value === 'accept') {
        data.alwaysAcceptWithdrawals = true
        data.alwaysRejectWithdrawals = false
      } else if (value === 'reject') {
        data.alwaysRejectWithdrawals = true
        data.alwaysAcceptWithdrawals = false
      } else if (value === 'unlimited') {
        data.alwaysAcceptWithdrawals = true
        data.alwaysRejectWithdrawals = true
        data.status = value
      } else if (value === 'variable') {
        data.hasVariableSchedule = true
        data.variableScheduleTime = this.formatTime(this.variableSchedule)
      }

      try {
        const response = await this.updateStore({ storeId: this.store.id, data })
        const updatedStore = response.data
        this.$emit('updated', updatedStore)
        this.$bvToast.toast('Tienda actualizada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        console.error('Error al actualizar la tienda:', error)
        this.$bvToast.toast('Error al actualizar la tienda', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    openModal () {
      this.$bvModal.show(`edit-variable-schedule-${this.store.id}`)
    },
    saveVariableSchedule () {
      this.change('variable')
    },
    formatTime (time) {
      // Eliminar los segundos del valor (si existen)
      return time.split(':').slice(0, 2).join(':')
    }
  },
  created () {
    this.setSelected(this.store)
  },
  watch: {
    store (value) {
      this.setSelected(value)
    }
  }
}
</script>
